import React from "react";

export default function StatPill({ label, value, tone = "gray" }) {
  const tones = {
    gray:    "bg-gray-50 text-gray-700 ring-gray-200 dark:bg-slate-800 dark:text-gray-200 dark:ring-slate-700",
    amber:   "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:ring-amber-700/50",
    blue:    "bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-900/20 dark:text-blue-300 dark:ring-blue-700/50",
    emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:ring-emerald-700/50",
    rose:    "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-900/20 dark:text-rose-300 dark:ring-rose-700/50",
    slate:   "bg-slate-50 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700",
  };
  const cls = tones[tone] || tones.gray;

  return (
    <div className={`flex items-center justify-between rounded-xl px-3 py-2 text-sm ring-1 ${cls}`}>
      <span className="font-medium">{label}</span>
      <span className="ml-3 font-semibold">{value}</span>
    </div>
  );
}
